import { render, staticRenderFns } from "./BioDropdown.vue?vue&type=template&id=f6a4cde4"
import script from "./BioDropdown.vue?vue&type=script&lang=js"
export * from "./BioDropdown.vue?vue&type=script&lang=js"
import style0 from "./BioDropdown.vue?vue&type=style&index=0&id=f6a4cde4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports